import React from 'react';
import mail from '../images/mail.svg';
import phone from '../images/call-answer.svg';
import whatsapp from '../images/whatsapp.svg';

const ModalFooter = () => (
	<div className="content-icons">
		<div className="box-icon">
			<img src={mail} alt="Ícone e-mail." className="icon-mail" />
			<a
				href="mailto:gearbox@webmotors.com.br"
				rel="noopener noreferrer"
				target="_blank"
			>
				gearbox@webmotors.com.br
			</a>
		</div>

		<div className="box-icon">
			<img src={phone} alt="Ícone telefone." className="icon-phone" />
			<a href="tel:1126260762" rel="noopener noreferrer" target="_self">
				(11) 2626-0762
			</a>
		</div>

		<div className="box-icon">
			<img src={whatsapp} alt="Ícone whatsapp." className="icon-whatsapp" />
			<a
				href="https://wa.me/5511989388514"
				rel="noopener noreferrer"
				target="_blank"
			>
				(11) 9 8938-8514
			</a>
		</div>
	</div>
);

export default ModalFooter;
